import { render, staticRenderFns } from "./SxSupplierView.vue?vue&type=template&id=5e31f8a6&scoped=true&"
import script from "./SxSupplierView.vue?vue&type=script&lang=js&"
export * from "./SxSupplierView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e31f8a6",
  null
  
)

export default component.exports